import * as actions from '@/modules/partner'

export const fetchPartner = async ({ commit, dispatch, rootGetters }) => {

  if (rootGetters['fetching/isFetching']('partner')) {
    return await rootGetters['fetching/getRequest']('partner');
  }

  const request = actions.fetchPartner();

  const response = await dispatch('fetching/doRequest', { id: 'partner', request }, { root: true })

  commit('upsert', response.data)

  return response;
}

export default {
  fetchPartner
}
